export default __webpack_public_path__ + "static/media/usdt.ae9e69d8.svg";